import React from "react";
import { useSelector } from "react-redux";
import Rating from "@material-ui/lab/Rating";
import TextField from "@material-ui/core/TextField";
import { customIcons, IconContainer } from "../../Branches/ReviewDrawerContent";
import Divider from "@material-ui/core/Divider";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

const CustomDivider = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "20px",
        marginBottom: "20px",
      }}
    >
      <div
        style={{
          width: "80%",
          borderTop: "2px solid #e0e0e0",
        }}
      ></div>
    </div>
  );
};
const ProductFeedbackSection = ({
  item,
  handleRating,
  handleComment,
  index,
  orderLength,
}) => {
  const language = useSelector((state) => state.store.language);
  const settings = useSelector((state) => state.store.store.settings);
  const currencyIcon = getCurrencyIcon(settings);
  const currency =
    language == "english"
      ?  settings?.currency_english : settings?.currency_local
  const lastItemIndex = orderLength - 1;

  return (
    <>
      <div
        key={item.product_id}
        className={"order-card"}
        style={{
          padding: "25px 5px",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: " 60px auto 0px",
            gridTemplateRows: " 60px auto 10px",
            alignItems: "center",
            direction: language === "english" ? "ltr" : "rtl",
            padding: "5px 15px",
          }}
        >
          <img
            style={{
              width: 60,
              height: 60,
              borderRadius: 4,
            }}
            src={item.photo}
            alt={item.name}
          />
          <div
            style={{
              textAlign: language === "english" ? "left" : "right",
              paddingLeft: language === "english" ? 16 : 0,
              paddingRight: language === "english" ? 0 : 16,
              fontWeight: "bold",
              lineHeight: 1.5,
            }}
          >
            <p
              className="cut-text-one-line-tracking"
              style={{
                marginBottom: 5,
              }}
            >
              {language === "english" ? item.name : item.ar_name}
            </p>
            <p className={`my-auto cut-text-one-line-tracking ${ currencyIcon}`}>
              {item.price} {currency}
            </p>
          </div>
        </div>

        <div>
          <Rating
            value={item.rating}
            onChange={(event, newValue) => {
              handleRating(item.product_id, newValue);
            }}
            classes={{ label: "large-star" }}
            style={{ marginTop: 10 }}
            IconContainerComponent={IconContainer}
            getLabelText={(value) => customIcons[value].label}
            key={item.product_id}
          />

          <div
            className="row mx-auto"
            dir={language == "english" ? "ltr" : "rtl"}
            style={{ width: "92%" }}
          >
            <h4
              className={language == "english" ? "text-left" : "text-right"}
              dir={language == "english" ? "ltr" : "rtl"}
              style={{
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
                marginTop: 10,
                marginBottom: 3,
              }}
            >
              {language == "english" ? "Leave us a comment" : "اترك لنا تعليق"}{" "}
            </h4>
            <TextField
              dir={language == "english" ? "ltr" : "rtl"}
              style={{ width: "100%", marginBottom: 10 }}
              id="outlined-textarea"
              multiline
              variant="outlined"
              value={item.comment}
              onChange={(event) =>
                handleComment(item.product_id, event.target.value)
              }
            />
          </div>
        </div>
      </div>
      {index !== lastItemIndex && <CustomDivider />}
    </>
  );
};

export default ProductFeedbackSection;
